<svg
  width="80px"
  height="80px"
  viewBox="0 0 80 80"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  aria-labelledby="income-icon-title income-icon-desc"
  role="img"
>
  <title id="income-icon-title">Income Icon</title>
  <desc id="income-icon-desc">This is an icon with a pound symbol depicting income.</desc>
  <defs>
    <rect
      id="path-1"
      x="0"
      y="0"
      width="80"
      height="80"
    ></rect>
  </defs>
  <g
    id="Income-Icon"
    stroke="none"
    stroke-width="1"
    fill="none"
    fill-rule="evenodd"
  >
    <g>
      <mask
        id="e04a01ef-41c3-4efd-a002-1521964eb899"
        fill="white"
      >
        <use xlink:href="#path-1"></use>
      </mask>
      <g id="Mask"></g>
      <g mask="url(#e04a01ef-41c3-4efd-a002-1521964eb899)">
        <g transform="translate(12.000000, 11.000000)">
          <g
            id="loan"
            transform="translate(0.000000, 32.512409)"
          >
            <path
              d="M18.3625444,1.86900074 C19.2937513,1.86900074 20.2444397,2.07120889 21.0238488,2.32964044 L26.7587112,5.55206826 C27.2448839,5.82565528 27.7973776,6.20664113 28.3562754,6.20664113 L35.3856445,6.20664113 C37.2044678,6.07549258 38.9806152,7.83904947 39.2723877,9.35392373 C39.3332089,9.91846374 39.3706172,10.2915297 39.3846127,10.4731217 L39.386127,10.4950007 L50.6104614,6.05513223 C51.2325324,5.83511318 53.7241699,6.0576835 54.6036621,7.80020059 C55.5649109,9.41527017 55.4294617,11.3422904 53.9977356,12.7865409 C53.3894511,13.1578666 47.0943095,16.1738151 35.1123108,21.8343864 C33.0179504,22.6485893 30.8166631,23.1933139 28.6981919,23.1933139 C26.7942054,23.1933139 24.8923481,22.7949072 23.065448,22.1859977 L12.6168396,17.9454398 C12.4874541,17.8931731 12.3476361,17.7715631 12.2080474,17.7715631 L9.28012695,17.7715631 L9.28012695,1.86900074 L18.3625444,1.86900074 Z M18.3625444,3.76915373 L10.9804321,3.76915373 L10.9804321,15.8715631 L12.2080474,15.8715631 C12.3476361,15.8715631 12.4859224,15.8984555 12.6153079,15.9507222 L12.6153079,15.9507222 L23.1669598,20.2177254 C24.9332027,20.9313506 26.7942054,21.2933139 28.6981919,21.2933139 C30.8166631,21.2933139 32.8678365,20.8496974 34.794726,19.9747177 C46.0218288,14.6426003 51.797981,11.8998195 52.1231828,11.7463753 L52.137708,11.7395641 C52.9069658,11.4319278 53.4041016,10.6986756 53.4041016,9.87162519 C53.4041016,9.20723056 53.0920349,8.60735605 52.5478992,8.22565716 C52.0070199,7.84634389 51.3409882,7.75547353 50.7189173,7.97549258 L50.7189173,7.97549258 L37.4601551,13.1724531 C36.829292,13.5178255 36.1138724,13.7027109 35.3856445,13.7027109 L35.3856445,13.7027109 L24.3509678,13.7027109 C23.7524511,13.7027109 23.2655186,14.1891601 23.2655186,14.7870828 C23.2655186,15.3859814 23.2394787,15.8714546 22.6399851,15.8714546 C22.0404915,15.8714546 21.5466953,15.3859814 21.5466953,14.7870828 C21.5466953,12.9933149 22.5554177,12.1317924 24.3509678,12.1317924 L24.3509678,12.1317924 L35.3856445,12.1317924 C35.6992308,12.1317924 36.0072813,12.0632601 36.2879785,11.9342198 C36.3571216,11.88564 36.4323432,11.8435663 36.5224355,11.8081074 C37.162742,11.4132876 37.556543,11.0263123 37.556543,10.2753848 C37.556543,9.07953955 36.5826779,8.10664113 35.3856445,8.10664113 L35.3856445,8.10664113 L28.3562754,8.10664113 C27.7973776,8.10664113 27.2448839,7.96198592 26.7587112,7.68839891 L26.7587112,7.68839891 L21.0238488,4.46597108 C20.2137781,4.00999272 19.2937513,3.76915373 18.3625444,3.76915373 L18.3625444,3.76915373 Z"
              id="Combined-Shape"
              fill="#BA2F7D"
              class="fill"
            ></path>
            <polygon
              id="Path"
              stroke="#BA2F7D"
              stroke-width="1.2825"
              class="stroke"
              points="7.24316294 18.0401983 0.404832864 18.0401983 0.404832864 0.69024874 7.24316294 0.69024874"
            ></polygon>
            <path
              d="M3.8475,7.19647984 C3.3752835,7.19647984 2.9925,7.5788834 2.9925,8.0506312 L2.9925,14.0305394 C2.9925,14.5022872 3.3752835,14.8846908 3.8475,14.8846908 C4.3197165,14.8846908 4.7025,14.5022872 4.7025,14.0305394 L4.7025,8.0506312 C4.7025,7.5788834 4.3197165,7.19647984 3.8475,7.19647984 Z"
              id="Shape"
              fill="#BA2F7D"
              fill-rule="nonzero"
              class="fill"
            ></path>
            <path
              d="M3.87471151,2.85899244 C3.27554355,2.85899244 2.7892623,3.34479103 2.7892623,3.94336429 C2.7892623,4.54193755 3.27554355,5.02773614 3.87471151,5.02773614 C4.47387948,5.02773614 4.96016073,4.54193755 4.96016073,3.94336429 C4.96016073,3.34479103 4.47387948,2.85899244 3.87471151,2.85899244 Z"
              id="Shape"
              fill="#BA2F7D"
              fill-rule="nonzero"
              class="fill"
            ></path>
          </g>
          <g
            id="Group-3"
            transform="translate(8.255656, 0.000000)"
          >
            <path
              d="M30.8929722,25.6154256 L30.8929722,23.9622029 L25.3321323,23.9622029 L25.3321323,23.8344539 C26.1286851,23.4436922 26.7524009,22.5344197 26.7524009,21.437281 C26.7524009,21.2268709 26.729857,21.0164607 26.6847691,20.8060506 L29.5027622,20.8060506 L29.5027622,19.3932967 L26.2338902,19.3932967 C26.0309947,18.852242 25.8506431,18.3036726 25.8506431,17.740074 C25.8506431,16.7030525 26.7148277,16.094366 28.1876988,16.094366 C29.0218247,16.094366 29.9386118,16.2747176 30.3819761,16.4851277 L30.3819761,14.8845076 C29.87098,14.6665828 28.9015904,14.5012605 27.9848032,14.5012605 C25.4147935,14.5012605 23.9043491,15.6209432 23.9043491,17.5146346 C23.9043491,18.1759236 24.1222739,18.7846101 24.3552281,19.3932967 L22.6418882,19.3932967 L22.6418882,20.8060506 L24.8211363,20.8060506 C24.8812534,21.0465193 24.911312,21.2945027 24.911312,21.5500008 C24.911312,22.7824031 23.9644663,23.8194246 22.6193443,24.0523787 L22.6193443,25.6154256 L30.8929722,25.6154256 Z"
              id="£"
              fill="#BA2F7D"
              fill-rule="nonzero"
              class="fill"
            ></path>
            <path
              d="M5.99434424,15.2 C9.14236732,15.2 11.6943443,17.7519769 11.6943443,20.9 C11.6943443,24.0480231 9.14236732,26.6 5.99434424,26.6 C2.8463212,26.6 0.294344262,24.0480231 0.294344262,20.9 C0.294344262,17.7519769 2.8463212,15.2 5.99434424,15.2 Z M5.99434426,16.7545455 C3.70487295,16.7545455 1.84888972,18.6105287 1.84888972,20.9 C1.84888972,23.1894713 3.70487295,25.0454545 5.99434426,25.0454545 C8.28381558,25.0454545 10.1397988,23.1894713 10.1397988,20.9 C10.1397988,18.6105287 8.28381558,16.7545455 5.99434426,16.7545455 Z"
              id="Combined-Shape"
              fill="#BA2F7D"
              fill-rule="nonzero"
              class="fill"
            ></path>
            <path
              d="M12.6443442,0 C15.7923673,0 18.3443443,2.55197694 18.3443443,5.70000002 C18.3443443,8.84802311 15.7923673,11.4 12.6443442,11.4 C9.4963212,11.4 6.94434426,8.84802311 6.94434426,5.70000002 C6.94434426,2.55197694 9.4963212,0 12.6443442,0 Z M12.6443443,1.55454545 C10.3548729,1.55454545 8.49888972,3.41052869 8.49888972,5.7 C8.49888972,7.98947131 10.3548729,9.84545455 12.6443443,9.84545455 C14.9338156,9.84545455 16.7897988,7.98947131 16.7897988,5.7 C16.7897988,3.41052869 14.9338156,1.55454545 12.6443443,1.55454545 Z"
              id="Combined-Shape"
              fill="#BA2F7D"
              fill-rule="nonzero"
              class="fill"
            ></path>
            <path
              d="M27.0383923,8.55 C33.9386645,8.55 39.5324404,14.1089116 39.5324404,20.9661766 C39.5324404,27.8234415 33.9386645,33.382353 27.0383923,33.382353 C20.1381201,33.382353 14.5443443,27.8234415 14.5443443,20.9661766 C14.5443443,14.1089116 20.1381201,8.55 27.0383923,8.55 Z M26.9781435,10.4267999 C21.1476738,10.4267999 16.4211441,15.1533295 16.4211441,20.9837993 C16.4211441,26.814269 21.1476738,31.5407986 26.9781435,31.5407986 C32.8086132,31.5407986 37.5351429,26.814269 37.5351429,20.9837993 C37.5351429,15.1533295 32.8086132,10.4267999 26.9781435,10.4267999 Z"
              id="Combined-Shape"
              fill="#BA2F7D"
              fill-rule="nonzero"
              class="fill"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
